import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import {
  useAddCurrency,
  useUpdateCurrency,
} from "../SuperSettingsScreen/hook/useSuperSetting";

type Props = {};

interface PlaylistTypeModalContentProps {
  currencyModal?: boolean;
  setCurrencyModal?: any;
  setCurrencyModalStatus?: any;
  currencyModalStatus?: string;
  selectedRowData?: any;
  setSelectedRowData?: any;
}

const CurrencyModalContent: React.FC<PlaylistTypeModalContentProps> = ({
  currencyModal,
  setCurrencyModal,
  setCurrencyModalStatus,
  currencyModalStatus,
  setSelectedRowData,
  selectedRowData,
}) => {
  const [formData, setFormData] = useState({
    currencyName: "",
    shortCode: "",
    symbol: "",
    conversionRate: "",
  });

  useEffect(() => {
    if (selectedRowData || currencyModalStatus === "Edit") {
      setFormData({
        currencyName: selectedRowData?.Name,
        shortCode: selectedRowData?.Shortcode,
        symbol: selectedRowData?.Symbol,
        conversionRate: selectedRowData?.Conversionrate,
      });
    }
  }, [selectedRowData]);

  const { mutate: addCurrency } = useAddCurrency();
  const { mutate: updateCurrency } = useUpdateCurrency();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (currencyModalStatus === "Edit") {
      const updateCurrencyBody = {
        name: formData?.currencyName,
        shortcode: formData?.shortCode,
        symbol: formData?.symbol,
        conversionrate: formData?.conversionRate,
      };

      updateCurrency(
        { id: selectedRowData?.CurrencyId, body: updateCurrencyBody },
        {
          onSuccess: () => {
            handleClose();
          },
          onError: () => {
            handleClose();
          },
        }
      );
    } else {
      const addCurrencyBody = {
        name: formData?.currencyName,
        shortcode: formData?.shortCode,
        symbol: formData?.symbol,
        conversionrate: formData?.conversionRate,
      };
      addCurrency(addCurrencyBody, {
        onSuccess: () => {
          handleClose();
        },
        onError: () => {
          handleClose();
        },
      });
    }
  };

  const handleClose = () => {
    setCurrencyModalStatus("");
    setCurrencyModal(false);
    setFormData({
      currencyName: "",
      shortCode: "",
      symbol: "",
      conversionRate: "",
    });
  };

  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <CustomInput
        label="Currency Name"
        type="text"
        asterisk
        required
        value={formData?.currencyName}
        style={{ borderRadius:'4px'}}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;
          // Allow only alphabets and spaces
          if (/^[A-Za-z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, currencyName: value }));
          }
        }}
      />
      {/* Second Input */}
      <CustomInput
        label="Currency Short Code"
        required
        asteriske
        type="text"
        value={formData?.shortCode}
        style={{ borderRadius:'4px'}}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;
          if (/^[A-Za-z\s]*$/.test(value)) {
            setFormData((prev) => ({ ...prev, shortCode: value }));
          }
        }}
      />

      {/* Third Input */}
      <CustomInput
        label="Currency Symbol"
        type="text"
        asterisk
        required
        value={formData?.symbol}
        style={{ borderRadius:'4px'}}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;
          setFormData((prev) => ({ ...prev, symbol: value }));
        }}
      />

      {/* Fourth Input */}
      <CustomInput
        label="Currency Conversion Rate"
        type="text"
        required
        asterisk
        value={formData?.conversionRate}
        style={{ borderRadius:'4px'}}
        // onChange={(e) => handleChange(e, "LeaveFrom")}
        onChange={(e) => {
          const value = e.target.value;

          setFormData((prev) => ({ ...prev, conversionRate: value }));
        }}
      />

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
          //   disabled={buttonDisable}
        >
          {currencyModalStatus === "Edit" ? "Update" : "Submit"}
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default CurrencyModalContent;
